import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Constants, HTTPStatusCode } from '../core/Constants';
import { API_CMS_ENDPOINT, API_ENDPOINT, BRAND } from '../core/DI';
import { LastSubject } from '../core/LastSubject';
import { CategoryFiltersRequestDto, SingleGenericStringValueIdCategoryFilter } from '../core/models/filter-backend';
import { KitComponentsDtoResponse } from '../core/models/kit-components.dto-response';

import { GenericCardAndFiltersDtoResponse } from '../core/models/generic-card-and-filter.dto-response';
import { MakeYearModel, SimpleMakeYearModel } from '../core/models/make-year-model.model';
import { PackageBuilderPackage } from '../core/models/package-builder-package';
import { PackageBuilderModel } from '../core/models/package-builder.model';
import { ProductDetailsDtoResponse } from '../core/models/product-details.dto-response';
import { ProductSpecsOptions } from '../core/models/product-specs-options.model';
import { Product } from '../core/models/product.model';
import { StaggeredPackageBuilderModel } from '../core/models/staggered-package-builder.model';
import { StaggeredProductDetailsDtoResponse } from '../core/models/staggered-product-details.dto-response';
import { WheelCategoryFilter } from '../core/models/wheel-category-filter.model';
import { FilterService } from '../shared/filter.service';
import { IProductService } from '../shared/iproduct.service';
import { PagingService } from '../shared/paging.service';
import { Helper } from './helper';
import { GenericSummaryCardDtoResponse } from 'app/core/models/generic-summary-card.dto-response';
import { ProductCustomerSizeModel } from './notes/models/product-customer-size-model';
import { CustomerSizeOffsetValidityDtoResponse } from 'app/core/models/customer-size-offset-validity.dto-response';
// import { URLSearchParams } from 'url';
import { ProductIdsModel } from 'app/core/models/product-ids.model';
import { BoltsNutsInfos } from 'app/core/models/bolts-nuts-infos.model';
import { CustomerFeedbackOption } from '../core/models/customer-feedback-option';

@Injectable()
export class WheelService implements IProductService {
    private wheelsSubject = new LastSubject<GenericCardAndFiltersDtoResponse>();
    private searchWithFilterInProgress = new Subject<boolean>();
    private lastStaggerType: string = null;
    private lastShowList: string = null;
    // djb:yagni-declared but not used
    private searchParams: MakeYearModel;
    private requestFilters: CategoryFiltersRequestDto;
    private wheelBySpecsSearchParams: WheelCategoryFilter;
    private lastSearchWithoutFilterResponse: GenericCardAndFiltersDtoResponse;
    private lastFrontTireId: string = null;
    private lastRearTireId: string = null;
    isInB2b: boolean;
    customParameter: {} = null;

  constructor(
    @Inject(API_ENDPOINT) private apiEndpoint: string,
    @Inject(API_CMS_ENDPOINT) private apiCmsEndpoint: string,
    @Inject(BRAND) private brand: string,
    private http: HttpClient,
    private pagingService: PagingService,
    private filterService: FilterService) {
      this.brand = brand;
      this.apiEndpoint = apiEndpoint;
      this.apiCmsEndpoint = apiCmsEndpoint;
      this.isInB2b = this.brand === Constants.BRAND_B2B;
    }

    get onProducts(): Observable<GenericCardAndFiltersDtoResponse> {
        return this.wheelsSubject.asObservable();
    }

    get onSearchWithFilter(): Observable<boolean> {
        return this.searchWithFilterInProgress.asObservable();
    }

    searchWithTextAndFilter(searchText: string, filters: CategoryFiltersRequestDto): void {
        throw new Error('NotSupportedException');
    }

    get onComponents(): Observable<KitComponentsDtoResponse> {
        throw new Error('NotSupportedException');
    }


    getProductDetailsByVehicleAndFilterAndStyleAndFinish(carDetails: MakeYearModel, wheelStagger: string, filters: CategoryFiltersRequestDto)
        : Observable<Array<GenericSummaryCardDtoResponse>> {
        const api = `${this.apiEndpoint}/wheels/makes/listing`;
        return this.http.post<Array<GenericSummaryCardDtoResponse>>(api, {
            baseFilter: carDetails,
            secondaryFilter: filters,
            loadSecondaryFilters: false,
            stagger: wheelStagger
        });
    }

    getProductDetailsBySpecs(wheelId: string): Observable<ProductDetailsDtoResponse> {
        const api = `${this.apiEndpoint}/wheels/?id=${encodeURIComponent(wheelId)}`;
        return this.http.get<ProductDetailsDtoResponse>(api);
    }

    getProductDetails(productId: string, carDetails: MakeYearModel,
        frontWheelOrTireId: string = '', rearWheelOrTireId: string = ''): Observable<ProductDetailsDtoResponse> {
        let api = `${this.apiEndpoint}/wheels/` +
            `makes/${Helper.encodeURIComponent2(carDetails.make)}/` +
            `years/${Helper.encodeURIComponent2(carDetails.getYearStr)}/` +
            `models/${Helper.encodeURIComponent2(carDetails.model)}/` +
            `submodels/${Helper.encodeURIComponent2(carDetails.submodel)}/` +
            `options/${Helper.encodeURIComponent2(carDetails.option)}/` +
            `summer/${Helper.encodeURIComponent2((carDetails.isSummerSeason ? 1 : 0).toString())}/`;// + `id/` + productId;
        let tireFirst = Helper.isProductTypePreferenceTire();
        if (tireFirst) {
            if (frontWheelOrTireId !== '' && rearWheelOrTireId !== '') {
                api += `tires/${frontWheelOrTireId}/${rearWheelOrTireId}/`;
            } else if (frontWheelOrTireId !== '') {
                api += `tires/${frontWheelOrTireId}/`;
            }
        }
        api += `id/${productId}/?tireFirst=${tireFirst}`;
        return this.http.get<ProductDetailsDtoResponse>(api);
    }

    getStaggeredProductDetails(productId: string, carDetails: MakeYearModel,
        frontWheelOrTireId: string = '', rearWheelOrTireId: string = ''): Observable<StaggeredProductDetailsDtoResponse> {
        let api = `${this.apiEndpoint}/wheels/` +
            `makes/${Helper.encodeURIComponent2(carDetails.make)}/` +
            `years/${Helper.encodeURIComponent2(carDetails.getYearStr)}/` +
            `models/${Helper.encodeURIComponent2(carDetails.model)}/` +
            `submodels/${Helper.encodeURIComponent2(carDetails.submodel)}/` +
            `options/${Helper.encodeURIComponent2(carDetails.option)}/` +
            `summer/${Helper.encodeURIComponent2((carDetails.isSummerSeason ? 1 : 0).toString())}/`; //+
        //`id/` + productId;
        let tireFirst = Helper.isProductTypePreferenceTire();
        if (tireFirst) {
            if (frontWheelOrTireId !== '' && rearWheelOrTireId !== '') {
                api += `tires/${frontWheelOrTireId}/${rearWheelOrTireId}/`;
            } else if (frontWheelOrTireId !== '') {
                api += `tires/${frontWheelOrTireId}/`;
            }
        }
        api += `id/${productId}/?tireFirst=${tireFirst}`;
        return this.http.get<StaggeredProductDetailsDtoResponse>(api);
    }

    getStaggeredProductDetailsBySpecs(productId: string): Observable<StaggeredProductDetailsDtoResponse> {
        throw new Error('Method not implemented.');
    }

  postProductToCart(id: string, qty: number, warningNotes: string[], pairNo: string, productType: string) {
    let api = `${this.apiCmsEndpoint}/cart/AddProduct`;
    const product: Product = this.createProduct(id, qty, warningNotes, pairNo);

    // WIP - VOLUME DISCOUNT
    if (this.customParameter !== null && this.customParameter['volumeDiscount'] !== null) {
      product.volumeDiscount = this.customParameter['volumeDiscount'];
      product.isVolumeDiscountEligible = true;
    }

    // WIP - SEASONAL CARE PLAN
    if (this.customParameter !== null && this.customParameter['scpReplaceCartContent'] !== null) {
        const _scpReplaceCartContent = this.customParameter['scpReplaceCartContent'];
        if (_scpReplaceCartContent)
            api = `${this.apiCmsEndpoint}/cart/AddProduct?scpReplaceCartContent=true`;
    }

    this.http.post(api, product).toPromise().then(response => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    }).catch((err: any) => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    });
  }

    postProductPairToCart(frontId: string, frontQty: number, frontWarningNotes: string[], rearId: string, rearQty: number, rearWarningNotes: string[], pairNo: string, productType: string) {
        throw new Error('Method not implemented.');
    }

  postProductsToCart(frontProduct: Product, rearProduct: Product, frontLabours: Product[], rearLabours: Product[], car: MakeYearModel) {
    let api = `${this.apiCmsEndpoint}/cart/AddPackage`;
    const packageBuilderPackage: PackageBuilderPackage = new PackageBuilderPackage();
    packageBuilderPackage.makeYearModel = car;
    packageBuilderPackage.package = new StaggeredPackageBuilderModel();
    packageBuilderPackage.package.front = new PackageBuilderModel({
      wheel: frontProduct,
      labours: frontLabours
    });
    packageBuilderPackage.package.rear = new PackageBuilderModel({
      wheel: rearProduct,
      labours: rearLabours
    });

    // WIP - SEASONAL CARE PLAN
    if (this.customParameter !== null && this.customParameter['scpReplaceCartContent'] !== null) {
        const _scpReplaceCartContent = this.customParameter['scpReplaceCartContent'];
        if (_scpReplaceCartContent)
            api = `${this.apiCmsEndpoint}/cart/AddPackage?scpReplaceCartContent=true`;
    }

    this.http.post(api, packageBuilderPackage).toPromise().then(response => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    }).catch((err: any) => {
      window.location.href = Constants.SHOPPING_CART_HREF;
    });
  }

    postToCartWithCar(frontId: string, frontQty: number, rearId: string = null,
        rearQty: number = null, frontWarningNotes: string[], rearWarningNotes: string[], car: MakeYearModel, pairNo: string) {
        const rearProduct = rearId && rearQty ? this.createProduct(rearId, rearQty, rearWarningNotes, pairNo) : null;
        this.postProductsToCart(this.createProduct(frontId, frontQty, frontWarningNotes, pairNo), rearProduct, null, null, car);
    }

    getProductFilters(): Observable<ProductSpecsOptions[]> {
        const api = `${this.apiEndpoint}/wheels/` +
            `filters/`;

        return this.http.get<ProductSpecsOptions[]>(api);
    }

    getProductByBrandFilters(): Observable<ProductSpecsOptions[]> {
        const api = `${this.apiEndpoint}/wheels/` +
            `filtersbybrand/`;
        return this.http.get<ProductSpecsOptions[]>(api);
    }

  populateProductByBrandFilters(selectedBrand: string = '', selectedCategory:string = ''): Promise<ProductSpecsOptions[]> {
    var query = new URLSearchParams();
    var api = `${this.apiEndpoint}/wheels/filtersbybrand/`;

    if (selectedBrand !== '')
      query.append("brands", selectedBrand);

    if (selectedCategory !== '')
      query.append("categories", selectedCategory);

    api += "?" + query;
    return this.http.get<ProductSpecsOptions[]>(api).toPromise();
  }

  getProductsByVehicleAndFilter(searchParams: SimpleMakeYearModel, filters: CategoryFiltersRequestDto,
    loadSecondaryFilters: boolean, groupResults: boolean = false)
    : void {

        const p: string = sessionStorage.getItem(`WheelsPaging`);
        if (p != null) {
            filters.paging.page = JSON.parse(p)["page"];
            filters.paging.pageSize = JSON.parse(p)["pageSize"];
            filters.paging.orderBy = JSON.parse(p)["orderBy"];
        }
        // Extract the stagger selected value from the filters and remove the stagger filter from the dto
        let stagger: string = null;
        if ((<any>filters).wheelstagger) {
            stagger = (<SingleGenericStringValueIdCategoryFilter>(<any>filters).wheelstagger).value.id;
            if (this.lastStaggerType !== stagger) {
                this.lastStaggerType = stagger;
                loadSecondaryFilters = true;
            }
            delete (<any>filters).wheelstagger;
        }
        let showList: string = null;
        if ((<any>filters).show) {
            showList = (<any>filters).show.values.map(v => v.id).join(',');
        }
        if (this.lastShowList !== showList) {
            this.lastShowList = showList;
            loadSecondaryFilters = true;
        }

        this.searchWithFilterInProgress.next(true);
        // djb:microsites use groupsResults, b2b does not
        groupResults = !this.isInB2b;

        let api = `${this.apiEndpoint}/wheels/makes/summary?groupResults=${groupResults}`;
        let _searchWheelsByVehicleRequestDto = {
            baseFilter: searchParams,
            secondaryFilter: filters,
            loadSecondaryFilters: loadSecondaryFilters,
            stagger: stagger
        };

        if (!this.isInB2b && this.customParameter != null)
            api = `${this.apiEndpoint}/wheels/items/search?searchtext=${this.customParameter['searchtext']}`;

        this.http.post<GenericCardAndFiltersDtoResponse>(api, _searchWheelsByVehicleRequestDto, { observe: 'response', responseType: 'json' })
            .subscribe(res => {
                let wheelsAndFiltersDto: GenericCardAndFiltersDtoResponse;
                if (res.status === HTTPStatusCode.NO_CONTENT) {
                    wheelsAndFiltersDto = {
                        categoryfilters: null,
                        productSummaryCards: [],
                        itemCount: 0,
                        sortOptions: [],
                        hasMoreThanOneOEMTPMS: false,
                        boltsNutsInfos: null,
                        styleFinish: [],
                        micrositeItemCounts: [],
                        alternateHexSizeExists: false
                    };
                } else {
                    wheelsAndFiltersDto = res.body;
                }
                sessionStorage.setItem("micrositeResults", JSON.stringify(wheelsAndFiltersDto.micrositeItemCounts));
                this.wheelsSubject.next(wheelsAndFiltersDto);
                this.searchWithFilterInProgress.next(false);
            },
                Helper.handleError);
    }

    getProductsByVehicleAndFilterForWheel(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto,
        loadSecondaryFilters: boolean, frontWheelId: string, rearWheelId: string,
        frontWheelQty: number, rearWheelQty: number, frontOffset?: number, rearOffset?: number)
        : void {
        throw new Error('NotSupportedException');
    }
    getProductsByVehicleAndFilterForTire(searchParams: MakeYearModel, filters: CategoryFiltersRequestDto,
        loadSecondaryFilters: boolean, frontTireId: string, rearTireId: string, frontTireQty: number, rearTireQty: number): void {
        const p: string = sessionStorage.getItem(`WheelsPaging`);
        if (p != null) {
            filters.paging.page = JSON.parse(p)["page"];
            filters.paging.pageSize = JSON.parse(p)["pageSize"];
            filters.paging.orderBy = JSON.parse(p)["orderBy"];
        }
        // Extract the stagger selected value from the filters and remove the stagger filter from the dto
        let stagger: string = null;
        if ((<any>filters).wheelstagger) {
            stagger = (<SingleGenericStringValueIdCategoryFilter>(<any>filters).wheelstagger).value.id;
            if (this.lastStaggerType !== stagger) {
                this.lastStaggerType = stagger;
                loadSecondaryFilters = true;
            }
            delete (<any>filters).wheelstagger;
        }
        let showList: string = null;
        if ((<any>filters).show) {
            showList = (<any>filters).show.values.map(v => v.id).join(',');
        }
        if (this.lastShowList !== showList) {
            this.lastShowList = showList;
            loadSecondaryFilters = true;
        }

        if (this.lastFrontTireId !== frontTireId) {
            this.lastFrontTireId = frontTireId;
            loadSecondaryFilters = true;
        }

        if (this.lastRearTireId !== rearTireId) {
            this.lastRearTireId = rearTireId;
            loadSecondaryFilters = true;
        }

        this.searchWithFilterInProgress.next(true);
        const api = `${this.apiEndpoint}/wheels/ByTire`;
        this.http.post<GenericCardAndFiltersDtoResponse>(api, {
            baseFilter: searchParams,
            secondaryFilter: filters,
            loadSecondaryFilters: loadSecondaryFilters,
            frontTireId: frontTireId,
            rearTireId: rearTireId,
            stagger: stagger,
            frontTireQty: frontTireQty,
            rearTireQty: rearTireQty
        }, { observe: 'response', responseType: 'json' })
            .subscribe(res => {
                let wheelsAndFiltersDto: GenericCardAndFiltersDtoResponse;
                if (res.status === HTTPStatusCode.NO_CONTENT) {
                    wheelsAndFiltersDto = {
                        categoryfilters: null,
                        productSummaryCards: [],
                        itemCount: 0,
                        sortOptions: [],
                        hasMoreThanOneOEMTPMS: false,
                        boltsNutsInfos: null,
                        styleFinish: [],
                        micrositeItemCounts: [],
                        alternateHexSizeExists: false
                    };
                } else {
                    wheelsAndFiltersDto = res.body;
                }
                this.wheelsSubject.next(wheelsAndFiltersDto);
                this.searchWithFilterInProgress.next(false);
            },
                Helper.handleError);
    }

    getProductsByVehicleAndFilterForAccessory(wheelCategoryFilter: WheelCategoryFilter,
        filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
        throw new Error('NotSupportedException');
    }

    getProductsBySpecsAndFilter(wheelCategoryFilter: WheelCategoryFilter,
        filters: CategoryFiltersRequestDto, loadSecondaryFilters: boolean): void {
        let showList: string = null;
        if ((<any>filters).show) {
            showList = (<any>filters).show.values.map(v => v.id).join(',');
        }

        if (this.lastShowList !== showList) {
            this.lastShowList = showList;
            loadSecondaryFilters = true;
        }
        const p: string = sessionStorage.getItem(`WheelsPaging`);
        if (p != null) {
            filters.paging.page = JSON.parse(p)["page"];
            filters.paging.pageSize = JSON.parse(p)["pageSize"];
            filters.paging.orderBy = JSON.parse(p)["orderBy"];
        }
        this.searchWithFilterInProgress.next(true);
        let url = decodeURIComponent(window.location.href);
        const showPromotions = url.includes("/promotions");

        var api = "";
        if (showPromotions) {
            api = `${this.apiEndpoint}/wheels/summary?showPromotions=true`;
        }
        else {
            api = `${this.apiEndpoint}/wheels/summary`;
        }

        this.http.post<GenericCardAndFiltersDtoResponse>(api, {
            baseFilter: wheelCategoryFilter,
            secondaryFilter: filters,
            loadSecondaryFilters: loadSecondaryFilters
        }, { observe: 'response', responseType: 'json' })
            .subscribe(res => {
                let wheelsAndFiltersDto: GenericCardAndFiltersDtoResponse;
                if (res.status === HTTPStatusCode.NO_CONTENT) {
                    wheelsAndFiltersDto = {
                        categoryfilters: [],
                        productSummaryCards: [],
                        itemCount: 0,
                        sortOptions: [],
                        hasMoreThanOneOEMTPMS: false,
                        boltsNutsInfos: null,
                        styleFinish: [],
                        micrositeItemCounts: [],
                        alternateHexSizeExists: false
                    };
                } else {
                    wheelsAndFiltersDto = res.body;
                }
                this.wheelsSubject.next(wheelsAndFiltersDto);
                this.searchWithFilterInProgress.next(false);
            },
                Helper.handleError);
    }

    getCategoryFiltersFromRoute(params: ParamMap): WheelCategoryFilter {
        return Helper.extractWheelCategoryFiltersFromRoute(params);
    }

    createProduct(id: string, qty: number, warningNotes: string[], pairNo: string): Product {
        return new Product({
            id: id,
            warningNotes: warningNotes,
            quantity: qty,
            type: Constants.PRODUCT_TYPE_WHEEL,
            pairNo: pairNo
        });
    }

    postKitToCart(id: string, qty: number): void {
        throw new Error('NotSupportedException');
    }


    searchComponents(searchText: string): void {
        throw new Error('NotSupportedException');
    }
    getCustomerSizeOffsetValidity(searchParams: SimpleMakeYearModel,
        productIds: ProductIdsModel,
        frontOffset: string, rearOffset: string, isAggressive: boolean)
        : Observable<CustomerSizeOffsetValidityDtoResponse> {
        let mym = new SimpleMakeYearModel();
        mym.make = searchParams.make;
        mym.year = searchParams.year;
        mym.model = searchParams.model;
        mym.submodel = searchParams.submodel;
        mym.option = searchParams.option;
        mym.isSummerSeason = true;
        let api = `${this.apiEndpoint}/wheels/validateoffsetforcustomersize` +
            `?frontWheelId=${productIds.front}` +
            `&rearWheelId=${productIds.rear}` +
            `&aggressive=${isAggressive}`;

        let fOffset: number;
        return this.http.post<CustomerSizeOffsetValidityDtoResponse>(api, {
            baseFilter: mym,
            frontOffset: frontOffset,
            rearOffset: rearOffset
        });
    }
    // Get BoltNutInfo
    getWheelBoltsNutsInfo(params: MakeYearModel, frontWheelId: string, rearWheelId: string)
        : Observable<BoltsNutsInfos> {
        if (frontWheelId) {
            const rearWheel = rearWheelId && rearWheelId !== '' ? `${rearWheelId}/` : '';
            const api = `${this.apiEndpoint}/wheels/boltsNutsInfo/` +
                `makes/${Helper.encodeURIComponent2(params.make)}/` +
                `years/${Helper.encodeURIComponent2(params.getYearStr)}/` +
                `models/${Helper.encodeURIComponent2(params.model)}/` +
                `submodels/${Helper.encodeURIComponent2(params.submodel)}/` +
                `options/${Helper.encodeURIComponent2(params.option)}/` +
                `summer/${Helper.encodeURIComponent2((params.isSummerSeason ? 1 : 0).toString())}/` +
                `wheels/${frontWheelId}/${rearWheel}`; // +

            return this.http.get<BoltsNutsInfos>(api);
        }
    }

    getPlacardToolKits(): Observable<any> {
        throw new Error('NotSupportedException');
    }

    getPlacardToolKitVehicles(kitNo: string): Observable<any> {
        throw new Error('NotSupportedException');
    }

    getPlacardToolPSIs(vehicleOptionID: number, tire: string, rearRire: string): Observable<any> {
        throw new Error('NotSupportedException');
    }

    submitCustomerFeedback(params: ParamMap, comments: string, categoryId: number, departmentResponsible: string, itemNo: string, customerFeedbackOptionId: string): Promise<any> {
        const api = `${this.apiCmsEndpoint}/angular/send/customerfeedback`;
        const makeYearModel = Helper.extractMakeYearModelFromRouteParam(params);
        const data = {
            makeYearModel: makeYearModel,
            comments: comments,
            categoryId: categoryId,
            departmentResponsible: departmentResponsible,
            itemNo: itemNo,
            customerFeedbackOptionId: customerFeedbackOptionId
        };

        return this.http.post(api, data).toPromise();
    }

    getCustomerFeedbackOptions(): Observable<CustomerFeedbackOption[]> {
        const api = `${this.apiCmsEndpoint}/angular/customerfeedbackoption`;

        return this.http.get<CustomerFeedbackOption[]>(api);
    }
}
